import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserClient } from '@benefitsui/app/api/benefits-clients';

@Component({
  selector: 'app-acceptence-page',
  templateUrl: './acceptence-page.component.html',
  styleUrls: ['./acceptence-page.component.scss']
})
export class AcceptencePageComponent implements OnInit {
  constructor(    
    private userClient: UserClient
  ){}
  @Input() hasRecords = false;
  @Input() termsConditions = false;
  @Input() electronicConsent = false;
  @Output() isDone = new EventEmitter<Event>();
  @Output() logout = new EventEmitter<Event>();
  
  headerMessage = 'Required terms of use (updated)';
  termsCondistionsPath = 'https://www.symetra.com/admin-pages/group-online-terms-and-conditions';
  electronicConsentPath = 'https://www.symetra.com/admin-pages/customer-disclosure';

  ngOnInit() {
    if (!this.hasRecords) {
      this.headerMessage = 'Required terms of use';
    }
  }

  onDisagree(): void {
    this.logout.emit();
  }

  onAgree(): void {
    this.userClient
      .accept({
        termsConditionsAccepted: true,
        electronicConsentAccepted: true
      }).subscribe();
    this.isDone.emit();
  }
}
